import { supabase } from '@/lib/supabase/client';
import { fromPostgrestError, normalizeError } from '@/lib/services/errors';
import type { Database } from '@/lib/supabase/database.types';
import type { PostgrestMaybeSingleResponse } from '@supabase/postgrest-js';
import type { UnitLeaseContact } from '@/lib/types/property';

type UnitLeaseContactsTable = Database['public']['Tables']['unit_lease_contacts'];
type UnitLeaseContactRow = UnitLeaseContactsTable['Row'];

export async function getUnitLeaseContact(unitId: string): Promise<UnitLeaseContact | null> {
  try {
    const response = (await supabase
      .from('unit_lease_contacts')
      .select('*')
      .eq('unit_id', unitId)
      .maybeSingle()
      .throwOnError()) as PostgrestMaybeSingleResponse<UnitLeaseContactRow>;

    return response.data === null ? null : mapUnitLeaseContactRow(response.data);
  } catch (error) {
    handleSupabaseError(error);
  }
}

function mapUnitLeaseContactRow(row: UnitLeaseContactRow): UnitLeaseContact {
  return {
    id: row.id,
    unitId: row.unit_id,
    tenantLabel: row.tenant_label,
    contactName: row.contact_name,
    primaryEmail: row.primary_email,
    officePhone: row.office_phone,
    officeTelHref: row.office_tel_href,
    cellPhone: row.cell_phone,
    cellTelHref: row.cell_tel_href,
    homePhone: row.home_phone,
    homeTelHref: row.home_tel_href,
    faxPhone: row.fax_phone,
    website: row.website,
    sourceSheet: row.source_sheet,
    sourceRow: row.source_row,
    sourceUpdatedAt: row.source_updated_at,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
  };
}

function handleSupabaseError(error: unknown): never {
  if (typeof error === 'object' && error !== null && 'code' in error && 'message' in error) {
    throw fromPostgrestError(error as Parameters<typeof fromPostgrestError>[0]);
  }

  throw normalizeError(error);
}
